import { ItemType, type ItemsWithPagination } from '@inno-sdks/files'

const normalizeUrl = (value: string): string => {
  try {
    return new URL(value, window.location.origin).toString()
  } catch {
    return value
  }
}

/** Returns whether the Files API response already contains this shortcut URL. */
export const hasShortcutWithUrl = (
  rootFolderItems: ItemsWithPagination | undefined,
  shortcutUrl: string
): boolean =>
  Boolean(
    rootFolderItems?.data.some(
      item =>
        item.type === ItemType.Shortcut &&
        normalizeUrl(item.metaData.shortcutUrl) === normalizeUrl(shortcutUrl)
    )
  )
